<template>
    <div class="modal-card" style="width: 800px; height: 800px">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="user"></b-icon>
                Ajout d'un sous-traitant
            </p>
        </header>
        <section class="modal-card-body">

            <div class="columns">
                <div class="column">
                    <b-field label="Sous-traitant">
                        <b-autocomplete
                            v-model="filterBox"
                            placeholder="Nom du sous-traitant"
                            keep-first
                            :data="filteredDataObj"
                            field="name"
                            open-on-focus
                            @select="option => (payload.sst = option)"
                        >
                            <template slot-scope="props">
                                <div class="media-content">
                                    {{ props.option }}
                                </div>
                            </template>
                        </b-autocomplete>
                    </b-field>

                    <b-field label="Coût">
                        <b-input type="number" min="0" step="0.01" v-model="payload.cost">
                        </b-input>
                    </b-field>

                    <b-field label="N° devis">
                        <b-input type="text" v-model="payload.devis">
                        </b-input>
                    </b-field>

                    <b-field label="Commentaire">
                        <b-input type="text" v-model="payload.comment">
                        </b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Date de livraison">
                        <b-datepicker
                            v-model="payload.livraison"
                            show-week-number
                            locale="fr-FR"
                            placeholder="Sélectionner"
                            icon="calendar"
                            icon-right="pen"
                            icon-right-clickable
                            @icon-right-click="clearDate()"
                            trap-focus>
                        </b-datepicker>
                    </b-field>

                    <b-field label="Famille de travaux">
                        <b-select
                            v-model="payload.famille"
                            placeholder="Sélectionner"
                            required
                            @input="setActions">
                            <option
                                v-for="option in typotravaux"
                                :value="option.famille"
                                :key="option.famille">
                                {{ option.famille }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Action de travaux">
                        <b-select
                            placeholder="Sélectionner"
                            v-model="payload.action"
                            @input="setIntitules">
                            <option
                                v-for="option in actions"
                                :value="getActionValue(option)"
                                :key="getActionValue(option)">
                                {{ getActionName(option) }}
                            </option>
                        </b-select>
                    </b-field>
                    
                    <b-field label="Intitulé">
                        <b-select
                            placeholder="Sélectionner"
                            v-model="payload.intitule">
                            <option
                                v-for="option in intitules"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="addTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "SSTAddModal",
        props: {
            SST: {
                type: Array,
                required: true
            },
            typotravaux: {
                type: Array,
                required: true
            },
        },
        computed: {
            filteredDataObj() {
                return this.SST.filter(option => {
                    return (
                        option
                            .toString()
                            .toLowerCase()
                            .indexOf(this.filterBox.toLowerCase()) >= 0
                    )
                })
            }
        },
        data() {
            return {
                payload: {
                    livraison: new Date(2026, 11, 31)
                },
                filterBox: '',
                actions: [],
                intitules: []
            };
        },
        methods: {
            setActions() {
                this.payload.action = null; // Reset the action
                this.payload.intitule = null; // Reset the intitule
                this.intitules = []; // Reset intitules
                
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (famille) {
                    this.actions = famille.actions;
                }
            },
            
            setIntitules() {
                this.payload.intitule = null; // Reset the intitule
                this.intitules = [];
                
                if (!this.payload.action) return;
                
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (!famille) return;
                
                const action = famille.actions.find(a => {
                    if (typeof a === 'string') {
                        return a === this.payload.action;
                    } else {
                        return a.name === this.payload.action;
                    }
                });
                
                if (action && typeof action === 'object' && action.subcategories) {
                    // Action avec sous-catégories
                    this.intitules = action.subcategories;
                } else {
                    // Action simple
                    this.intitules = [this.payload.action];
                }
            },
            
            getActionValue(action) {
                return typeof action === 'string' ? action : action.name;
            },
            
            getActionName(action) {
                return typeof action === 'string' ? action : action.name;
            },
            
            clearDate() {
                this.payload.livraison = null;
            },
            
            addTodo() {
                // Vérifier le sous-traitant
                if (!this.payload.sst || this.payload.sst === '') {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner un sous-traitant`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier la famille de travaux
                if (!this.payload.famille || this.payload.famille === '') {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner une famille de travaux`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }

                // Vérifier le commentaire si "Autre" est sélectionné dans une des catégories
                if (((this.payload.famille !== undefined && this.payload.famille === 'Autre') || 
                    (this.payload.action !== undefined && this.payload.action === 'Autre') || 
                    (this.payload.intitule !== undefined && this.payload.intitule === 'Autre')) && 
                    (!this.payload.comment || this.payload.comment.trim() === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de renseigner un commentaire pour préciser "Autre"`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier l'action de travaux (sauf si famille = "Autre")
                if (this.payload.famille !== 'Autre' && (!this.payload.action || this.payload.action === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner une action de travaux`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier l'intitulé (sauf si famille = "Autre" ou action = "Autre")
                if (this.payload.famille !== 'Autre' && 
                    this.payload.action !== 'Autre' && 
                    (!this.payload.intitule || this.payload.intitule === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner un intitulé`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier le coût
                if (!this.payload.cost || this.payload.cost === '' || isNaN(parseFloat(this.payload.cost)) || parseFloat(this.payload.cost) < 0) {
                    this.$buefy.snackbar.open({
                        message: `Merci de saisir un coût valide`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                                
                // Si tout est OK
                this.$emit("add-sst", this.payload);
            }
        }
    };
</script>

<style scoped></style>